import {WithSummaryModel} from '../../../../../common/entity/dto/plain/withSummary.model';
import {ConsultationSummaryModel} from './consultationSummary.model';
import {AgendaEventModel} from '../../../../../agenda/modules/event/api/entity/agendaEvent.model';
import {AudioTranscriptionModel} from '../../../../../common/audio/transcription/api/model/audioTranscription.model';
import {ConsultationLayout} from "./consultationLayout.model";
import {ConsultationGetPartnerAnamnesisDto} from "../service/anamnesis/consultationGetPartnerAnamnesis.service";

export class ConsultationModel extends WithSummaryModel<ConsultationSummaryModel> {

    event: AgendaEventModel;
    comment: string;
    audioTranscriptions: AudioTranscriptionModel[] = [];
    anamnesis: string;
    diagnostic: string;
    treatment: string;
    observation: string;
    layout: string;
    conclusion: string;

    get layoutAsObject(): ConsultationLayout {
        return this.layout ? ConsultationLayout.fromJSONString(this.layout) : null;
    }

    get formattedAnamnesis(): string {
        return ConsultationGetPartnerAnamnesisDto.formatAnamnesis(this.anamnesis);
    }
}

export class ConsultationLayoutModel {

}
